import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import Axios from '../../../../../axios/Axios';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../../redux/features/appSlice';
import { LoadingButton } from '@mui/lab';
import dayjs from 'dayjs';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

export default function EditAttendanceModal({ rowData, setGetAttendanceDataFromServer }) {

  const userId = sessionStorage.getItem("user_id");
  const dispatch = useDispatch();
  const [openEditAttendanceModal, setOpenEditAttendanceModal] = useState(false);
  const [attendanceStatus, setAttendanceStatus] = useState(rowData[5]);
  const [isLoading, setLoading] = useState(false);

  // useEffect(() => {
  //   // setAttendanceStatus(rowData[5])
  //   console.log(dayjs(rowData[7]).format("DD-MM-YYYY"));
  // }, [rowData]);
  // console.log(rowData);
const rowDate = dayjs(rowData[7]).format("DD-MM-YYYY")

  async function editAttendanceForTeacher() {

    // console.log(rowData);
    const editedData = {
      teacher_id: rowData[0],
      attendance_status: attendanceStatus,
      greet_session_name: rowData[6],
      posted_by: userId,
      batch_id: rowData[2],
      greet_session_datetime: rowData[7],
      attendance_id: rowData[4]
    }

    const viewData = {
      batch_id: rowData[2],
      greet_session_datetime: rowDate,
    }

    try {
      setLoading(true);
      const response = await Axios("put", "attendance/update/trainingattendance", true, editedData);
      if (response.status === 200) {
        // setLoading(false);
        const viewAttendance = await Axios("post", "attendance/view/attendancelistbybatch", true, viewData);
          
        if (viewAttendance.status === 200) {
          setGetAttendanceDataFromServer(viewAttendance.data);
          setLoading(false);
          setOpenEditAttendanceModal(false);
          dispatch(
            showSnackbar({
              message: "Attendance updated successfully",
              severity: "success",
            })
          );
        }
      }

    } catch (err) {
      console.log(err);
      setLoading(false);
      setOpenEditAttendanceModal(false);
      dispatch(
        showSnackbar({
          message: "Attendance updated successfully",
          severity: "success",
        })
      );
    }
  }

  return (
    <div>
      <Button fullWidth sx={{ p: 0, color: "black" }} size='small' variant='text' onClick={() => setOpenEditAttendanceModal(true)}>Edit</Button>
      <Modal
        open={openEditAttendanceModal}
        onClose={() => setOpenEditAttendanceModal(false)}
      >
        <Box sx={style}>
          <Typography variant='h5'>Edit {rowData[1]}'s attendance</Typography>
          <Stack spacing={3} mt={2}>
            <Typography style={{ display: "none" }}>Teacher id : &nbsp;<Typography component="span" variant='h6'>{rowData[0]}</Typography></Typography>
            <Typography>Teacher name : &nbsp;<Typography component="span" variant='h6'>{rowData[1]}</Typography></Typography>
            <Typography>Group name : &nbsp;<Typography component="span" variant='h6'>{rowData[3]}</Typography></Typography>
            <Typography>Attendance status : &nbsp;<Typography component="span" variant='h6'>{rowData[5]}</Typography></Typography>
            <Typography>Session date : &nbsp;<Typography component="span" variant='h6'>{
            // new Date(Date.parse(rowData[7])).toLocaleString("en-IN", {
            //   timeZone: "Asia/Calcutta",
            // })
            rowDate
            }</Typography></Typography>
            {/* <TextField
                label="Attendance status"
                size='small'
                select
                value={attendanceStatus}
                onChange={(e) => setAttendanceStatus(e.target.value)}
            >
                <MenuItem value="attended">Attended</MenuItem>
                <MenuItem value="not attended">Not attended</MenuItem>
            </TextField> */}
            <FormControl fullWidth>
              <InputLabel id="attendance-status-label">Attendance status</InputLabel>
              <Select
                labelId="attendance-status-label"
                id="attendance-status"
                value={attendanceStatus}
                onChange={(e) => setAttendanceStatus(e.target.value)}
                label="Attendance status"
                size='small'
              >
                <MenuItem value="attended">Attended</MenuItem>
                <MenuItem value="not attended">Not attended</MenuItem>
              </Select>
            </FormControl>

            <Stack direction="row" spacing={5}>
              <Button onClick={() => setOpenEditAttendanceModal(false)} color='inherit' fullWidth variant='contained'>Cancel</Button>
              <LoadingButton loading={isLoading} onClick={() => editAttendanceForTeacher()} fullWidth variant='contained'>Save changes</LoadingButton>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
}